import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  width: 100%;
  font-size: ${FONT_SIZE.M}px;
  :first-of-type {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
  }
`;

export const ULListWrapper = styled.ul`
  width: 100%;

  > li {
    > a {
      display: flex;
      align-items: center;
      height: 40px;
      width: 100%;
      padding: 8px;
      font-size: ${FONT_SIZE.S}px;

      :hover {
        background-color: ${COLOR.GRAY200.code};
      }
    }
  }
`;
